module.exports = __webpack_public_path__ + "static/media/chart1.f7fd1dfc.jpg";